"use client"
import React, { createContext, useContext, useState, ReactNode } from 'react'

interface SharedImage {
  src: string
  alt: string
  rect: DOMRect
}

interface TransitionImageLayerContextProps {
  setSharedImage: (image: SharedImage | null) => void
  sharedImage: SharedImage | null
}

const TransitionImageLayerContext = createContext<TransitionImageLayerContextProps | undefined>(undefined)

export const useTransitionImageLayer = () => {
  const context = useContext(TransitionImageLayerContext)
  if (!context) throw new Error('useTransitionImageLayer must be used within a TransitionImageLayerProvider')
  return context
}

export const TransitionImageLayerProvider = ({ children }: { children: ReactNode }) => {
  const [sharedImage, setSharedImage] = useState<SharedImage | null>(null)

  return (
    <TransitionImageLayerContext.Provider value={{ setSharedImage, sharedImage }}>
      {children}
    </TransitionImageLayerContext.Provider>
  )
}
